import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { AlertifyService } from '@services/alertify.service';
import { CustomValidators } from '@app/shared/validators/custom.validators';
import { UserService } from '@services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  email: string;
  token: string;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private alertify: AlertifyService,
    private actRoute: ActivatedRoute,
    private userService: UserService, 
    private router: Router,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

  ngOnInit() {
    this.createResetForm();
    // Try to get from route parameters first (original method)
    this.email = this.actRoute.snapshot.params['email'];
    this.token = this.actRoute.snapshot.params['token'];
    
    // If not found in params, try query parameters (alternative method)
    if (!this.email || !this.token) {
      this.email = this.actRoute.snapshot.queryParams['email'];
      this.token = this.actRoute.snapshot.queryParams['token'];
    }
    
    // No need to decode here - the server will handle the URL decoding
  }

  createResetForm() {
      this.resetForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
    }, { validator: CustomValidators.compareTwoPasswords });
  }

  resetPassword() {
    const password: any = this.resetForm.get('password').value;

    this.userService.resetPassword(this.email, password, this.token).subscribe(next => {
      
      this.translate.get(["ALERTIFY.CHANGE_PASSWORD_SUCCESSFUL", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
        this.alertify.success(text);

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
          modal_body_html: text['ALERTIFY.CHANGE_PASSWORD_SUCCESSFUL'],
          modal_color_variant: "success"
        })
      });

      // tslint:disable-next-line:no-shadowed-variable
    }, error => {

      console.error(error); //  'Failed to loginsss');

      this.translate.get(["ALERTIFY.CHANGE_PASSWORD_FAILED", "BOOTSTRAP.MODAL.ERROR"]).subscribe((text: string) => {
        this.alertify.error(text);

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
          modal_body_html: text['ALERTIFY.CHANGE_PASSWORD_FAILED'],
          modal_color_variant: "danger"
        })
      });

    }, () => {
        this.router.navigate(['/login']);
    }
    );
  }
}
